import { jsx as i, jsxs as h } from "react/jsx-runtime";
import { memo as n } from "react";
import { useHasGrowthApplied as m, useHasFilterApplied as f, useHasPeriodApplied as c } from "../metricDisplay/MetricDisplay.hooks.js";
import { v as r } from "../index-e062cb03-BJ_Yd14E.js";
import { u as d } from "../styled-components.browser.esm-BFmoFexH.js";
import { IconContainer as t } from "@biron-data/react-components";
const D = n(({
  metric: e,
  children: o
}) => {
  const s = m(e), p = f(e), l = c(e);
  return /* @__PURE__ */ i(
    x,
    {
      $iswidthlimited: [s, p, l].filter((a) => a).length > 1 && !o ? 1 : 0,
      children: /* @__PURE__ */ h(w, { children: [
        o,
        p && /* @__PURE__ */ i(t, { size: 14, children: /* @__PURE__ */ i(r.Filter, {}) }),
        l && /* @__PURE__ */ i(t, { size: 14, children: /* @__PURE__ */ i(r.Date, {}) }),
        s && /* @__PURE__ */ i(t, { size: 14, children: /* @__PURE__ */ i(r.Growth, {}) })
      ] })
    }
  );
}), x = d.div`
    display: flex;
    ${({ $iswidthlimited: e }) => e ? "width: 38px;" : ""}
    overflow: hidden;
    flex-wrap: wrap;
    height: 100%;
`, w = d.div`
    display: flex;
    gap: 3px;
    height: 100%;
`;
export {
  D as default
};
//# sourceMappingURL=MetricDetails.js.map
